module.exports = __webpack_public_path__ + "static/media/egbalmomon.5adf2aea.jpeg";